export function mastheadSlideAutoplay() {
    var mastheadSlider = document.querySelector(".site-masthead__slides");
    
    if (!mastheadSlider) return;
    
    var flkty = new Flickity(mastheadSlider, {
        cellAlign: "left",
        contain: true,
        prevNextButtons: !!mastheadSlider.closest(".site-masthead--banner"), // Arrows on banner mastheads only
        draggable: true,
        wrapAround: true, // Ensures looping through slides
        autoPlay: false, // Turn off Flickity’s default autoplay
    });
    var slideDurations = [];
    var slideElements = mastheadSlider.querySelectorAll(".site-masthead__slides-slide");

    // Get slide durations from data attributes
    slideElements.forEach((slide, index) => {
        var duration = slide.getAttribute("data-slide-duration");
        slideDurations[index] = duration ? parseInt(duration, 10) * 1000 : 3000;
    });

    var currentIndex = 0;
    var slideTimeout;

    function scheduleNextSlide() {
        clearTimeout(slideTimeout);
        slideTimeout = setTimeout(() => {
            flkty.next();
            currentIndex = flkty.selectedIndex;
            scheduleNextSlide();
        }, slideDurations[currentIndex]);
    }

    flkty.on("change", function (index) {
        currentIndex = index;
        scheduleNextSlide();
    });

 
    scheduleNextSlide();
}
